// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Future from "./Future.bs.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";

function fromPromise(promise, errorTransformer) {
  return Future.make(undefined, (function (callback) {
                return Js_promise.$$catch((function (error) {
                              return Promise.resolve((Curry._1(callback, {
                                                TAG: /* Error */1,
                                                _0: Curry._1(errorTransformer, error)
                                              }), undefined));
                            }), Js_promise.then_((function (res) {
                                  return Promise.resolve((Curry._1(callback, {
                                                    TAG: /* Ok */0,
                                                    _0: res
                                                  }), undefined));
                                }), promise));
              }));
}

function toPromise(future) {
  return new Promise((function (resolve, param) {
                Future.get(future, (function (value) {
                        resolve(value);
                      }));
              }));
}

var FutureError = /* @__PURE__ */Caml_exceptions.create("FutureJs.FutureError");

function resultToPromise(future) {
  return new Promise((function (resolve, reject) {
                Future.map(Future.mapError(future, (function (param) {
                            return {
                                    RE_EXN_ID: FutureError
                                  };
                          })), (function (result) {
                        if (result.TAG === /* Ok */0) {
                          return resolve(result._0);
                        } else {
                          return reject(result._0);
                        }
                      }));
              }));
}

export {
  fromPromise ,
  toPromise ,
  FutureError ,
  resultToPromise ,
}
/* No side effect */
